<ndt-register-view
   [name]="name"
   [totalCount]="totalCount"
   [callState]="callState"
   [hasNextPage]="hasNextPage"
   [pagingCallState]="pagingCallState"
   [searchText]="searchText"
   [showCreate]="promptPrivileges?.canAdd"
   (create)="onCreate()"
   (quickFilterChange)="onQuickFilterChange($event)"
   (loadMore)="onLoadMore()"
>
   <ndt-register-quick-filter>
      <mat-form-field id="promptTypeSelect">
         <mat-label>Filter by type</mat-label>
         <input
            [lcsSingleSelect]="promptTypeSelect"
            ndtPromptTypeSelect
            autocomplete="off"
            type="text"
            [ngModel]="selectedPromptType"
            (ngModelChange)="onPromptTypeSelected($event)"
            id="prompt-type"
         />
         <ndt-prompt-type-select
            #promptTypeSelect
            isIncludeEmptyOption="true"
            [excludedPromptTypes]="'SystemPrompt'"
         ></ndt-prompt-type-select>
      </mat-form-field>
      <ndt-register-quick-filter class="inactive-prompts-toggle">
         @if (includeInactivePromptsControl) {
         <mat-slide-toggle
            class="slide-toggle"
            id="toggle-show-all-prompts"
            color="primary"
            [ngModel]="includeInactive"
            (ngModelChange)="includeInactivePromptsChange($event)"
         >
            Include Inactive
         </mat-slide-toggle>
         }
      </ndt-register-quick-filter>
   </ndt-register-quick-filter>
   <lcs-responsive-table [columns]="columns">
      <table lcs-table [dataSource]="dataSource">
         <tr lcs-row *lcsResponsiveRowDef="let prompt"></tr>
         <tr lcs-header-row *lcsResponsiveHeaderRowDef></tr>
         <ng-container lcsColumnDef="name" width="6">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="promptName-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               [sortDirection]="getOrderingOption(orderingOptions, 'name')"
               sortField="name"
               >Name <mat-icon class="mat-icon-sort">{{ getSort('name') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let prompt">
               <a [routerLink]="getRouterLink(prompt.promptId)">
                  {{ prompt.name }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="type" width="3">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="promptType-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               [sortDirection]="getOrderingOption(orderingOptions, 'promptTypeName')"
               sortField="promptTypeName"
               >Type <mat-icon class="mat-icon-sort">{{ getSort('promptTypeName') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let prompt">
               <a [routerLink]="getRouterLink(prompt.promptId)">
                  {{ prompt.typeName | addSpaces }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="active" width="2">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="promptActive-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               [sortDirection]="getOrderingOption(orderingOptions, 'isActive')"
               sortField="isActive"
               >Active <mat-icon class="mat-icon-sort">{{ getSort('isActive') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let prompt">
               @if (prompt.active) {
               <mat-icon>check</mat-icon>
               }
            </td>
         </ng-container>
         <ng-container lcsColumnDef="inUse" width="2">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="promptActive-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               [sortDirection]="getOrderingOption(orderingOptions, 'isInUse')"
               sortField="isInUse"
               >In Use <mat-icon class="mat-icon-sort">{{ getSort('isInUse') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let prompt">
               @if (prompt.isInUse) {
               <mat-icon>check</mat-icon>
               }
            </td>
         </ng-container>
         <ng-container lcsColumnDef="promptActionsMenu" width="3">
            <th lcs-header-cell *lcsHeaderCellDef id="prompts-actions-menu-column-header"></th>
            <td lcs-cell *lcsCellDef="let prompt" class="actions-menu-cell">
               <div class="prompt-actions">
                  @if (showExtensionRegisterPopup != false) {
               <mat-icon
                  class="tooltip"
                  [appTooltip]="isActionMenuHovered ? '' : (prompt.promptId | promptRegisterHover : prompt.typeName)"
                  >information</mat-icon
               >
               }
               <button
                  type="button"
                  aria-label="Prompt Actions"
                  matTooltip="More Actions"
                  mat-icon-button
                  [matMenuTriggerFor]="promptsRolesMenu"
                  id="extension-group-more-actions"
                  (mouseenter)="isActionMenuHovered = true"
                  (mouseleave)="isActionMenuHovered = false"
               >
                  <mat-icon> more_horiz </mat-icon>
               </button>
               </div>
               <mat-menu #promptsRolesMenu="matMenu">
                  <a mat-menu-item [routerLink]="getRouterLink(prompt.promptId)"> Details </a>
               </mat-menu>
            </td>
         </ng-container>
      </table>
   </lcs-responsive-table>
</ndt-register-view>
